import React, {useEffect, useState} from "react";
import Tabs from "../Tabs";
import CmpPopupConfig from "./CmpPopupConfig";
import Vendors from "./Vendors";
import Purposes from "./Purposes";


export default function CmpConfiguration({cmpConfig,
                                           updateCmpConfig,
                                           params,
                                           vendors,
                                           availableVendors,
                                           getAvailableVendors,
                                           updateVendor,
                                           createVendor,
                                           addVendor,
                                           removeVendor,
                                           vendorsLoaderProps,
                                           purposes,
                                           languages,
                                           isAvailableVendorsLoading,
                                           children,
                                           addConsentable,
                                           createPurpose,
                                           updatePurpose,
                                           removeConsentable,
                                           tabProps,
                                           purposesLoaderProps,
                                           cmpConfigLoaderProps}) {

  return (
    <Tabs {...tabProps}>
      <CmpPopupConfig
        icon={"mobile"}
        as={"cmp.popup"}
        cmpConfig={cmpConfig}
        updateCmpConfig={updateCmpConfig}
        params={params}
        {...cmpConfigLoaderProps}/>
      <Vendors
        icon={"listCheck"}
        as={"cmp.vendors"}
        vendors={vendors}
        params={params}
        availableVendors={availableVendors}
        getAvailableVendors={getAvailableVendors}
        updateVendor={updateVendor}
        createVendor={createVendor}
        addVendor={addVendor}
        removeVendor={removeVendor}
        isAvailableVendorsLoading={isAvailableVendorsLoading}
        {...vendorsLoaderProps}/>
      <Purposes
        icon={"listCheck"}
        as={"cmp.purposes"}
        purposes={purposes}
        languages={languages}
        params={params}
        addConsentable={addConsentable}
        createPurpose={createPurpose}
        updatePurpose={updatePurpose}
        removeConsentable={removeConsentable}
        purposesLoaderProps={purposesLoaderProps}/>
      {children}
    </Tabs>
  )
}
